export enum CertificateStatus {
    ValidCertificate = 1,
    ExpiredCertificate = 2,
    CertificateNotFound = 3,
    InvalidSearchTerm = 4,
    NotSelectable = 5,
    PrerequisiteCheck = 6
}
